import Dexie from 'dexie';

export const db = new Dexie('TechPOS');

export const init = async (productSchema) => {
    try {
        await Dexie.delete('TechPOS');

        db.version(1).stores({
            products: productSchema
        });

    } catch (err) {
        alert(`Error during database creation: ${err}`);
    }
}
 
export const product = {
    addItem: async (item) => {
        await db.table("products").add(item);
    },

    addItems: async (items) => {
        await db.table("products").bulkAdd(items);
    },

    getAll: async () => {
        return db.open().then(async () => await db.table("products").toArray());
    },

    getAllByPage: async (offset, limit) => {
        return db.open().then(async () => await db.table("products").offset(offset).limit(limit).toArray());
    },

    getFilter: async (searchText) => {
        return db.open().then(async () => await db.table("products")
            .filter(product =>
                product.sku.toLowerCase().includes(searchText.toLowerCase()) ||
                product.name.toLowerCase().includes(searchText.toLowerCase()) ||
                (product.description && product.description.toLowerCase().includes(searchText.toLowerCase())) || 
                (product.category && product.category.toLowerCase().includes(searchText.toLowerCase())))
            .toArray());
    },

    getByCategory: async (categoryId) => {
        return db.open().then(async () => await db.table("products").where('categoryId').equals(categoryId).toArray());
    },

    getById: async (id) => {
        return db.open().then(async () => await db.table("products").get(id));
    },

    getByBarcode: async (barcode) => {
        return db.open().then(async () => await db.table("products").where('barcode').equals(barcode).first());
    },

    getByLot: async (lotNumber) => {
        return db.open().then(async () => await db.table("products").where('lot').equals(lotNumber).first());
    },

    updateItem: async (id, updatedData) => {
        await db.products.update(id, updatedData);
    },

    deleteItem: async (id) => {
        await db.products.delete(id);
    },

    clearTable: async () => {
        await db.products.clear();
    }

};

